/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import { ArrowIcon } from "./Icons";
import { fontSize } from "../common/styled-mixins";

const SectionTitle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  align-self: flex-start;
  width: 100%;
  padding: 18px 0;
  padding-left: 28px;
  padding-right: 18px;
  color: #99959d;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.foreground};
  }

  ${props =>
    props.active &&
    css`
      color: ${({ theme }) => theme.foreground};
    `};
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.mainLight};
`;

const IconContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 12px;
  color: ${({theme}) => theme.dealIconColor}
`;

const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 10px;
  height: 10px;
  margin-left: auto;
  transform: rotate(0deg) translateX(-50%);
  transform-origin: 0;
  transition: transform 0.2s linear;

  ${props =>
    props.active &&
    css`
      transform: rotate(-180deg) translateX(-50%);
    `};
`;

const TextContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  font-size: ${fontSize(12)};
  line-height: 1;
  text-transform: uppercase;
  user-select: none;
`;

type State = {
  isOpen: boolean
};

type Props = {
  title: React.Node | string,
  Icon: React.ComponentType<*>,
  isOpenByDefault: boolean,
  children?: (props: State) => React.Node
};

function toggle(state: State): State {
  return {
    isOpen: !state.isOpen
  };
}

class CollapsibleSection extends React.Component<Props, State> {
  state = {
    isOpen: Boolean(this.props.isOpenByDefault)
  };

  render() {
    const { title, Icon, children } = this.props;
    const { isOpen } = this.state;

    if (typeof children !== "function") {
      return null;
    }

    return (
      <Container>
        <SectionTitle
          id="title-container"
          active={isOpen}
          onClick={() => this.setState(toggle)}
        >
          <IconContainer>
            <Icon />
          </IconContainer>
          <TextContainer>{title}</TextContainer>
          <ArrowContainer active={isOpen}>
            <ArrowIcon />
          </ArrowContainer>
        </SectionTitle>
        {children({
          isOpen
        })}
      </Container>
    );
  }
}

export default CollapsibleSection;



// WEBPACK FOOTER //
// ./src/components/TradeControls/CollapsibleSection.js